import { nullable, number, struct, union } from 'io-ts/Decoder';

import { CommonId, PackId } from './Id';

const PriceUnitWithoutPack = struct({
	priceUnit: PackId,
	packQty: number, // enforce integer
	min: nullable(number),
	inc: nullable(number),
});

const PriceUnitWithPack = struct({
	priceUnit: CommonId,
	min: nullable(number),
	inc: nullable(number),
});

export const PriceUnitItem = union(PriceUnitWithoutPack, PriceUnitWithPack);
